import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang";
import SEO from "@/components/places/SEO";

const T = {
  pt: { title: "Esse lugar ainda não existe.", body: "Mas a Places pode ajudar você a construir um.", cta: "Voltar para a Home" },
  en: { title: "This place doesn't exist yet.", body: "But Places can help you build one.", cta: "Back to home" },
  es: { title: "Este lugar aún no existe.", body: "Pero Places puede ayudarte a construir uno.", cta: "Volver al inicio" },
};

export default function NotFound() {
  const { lang } = useLang();
  const t = T[lang] || T.pt;
  return (
    <>
      <SEO title={t.title} noindex />
      <section className="theme-light min-h-screen flex items-center justify-center grain relative overflow-hidden pt-32 pb-16" data-testid="not-found">
        <div className="shape-blob bg-accent-orange w-[500px] h-[500px] opacity-30" />
        <div className="relative text-center px-6">
          <div className="font-display text-[10rem] md:text-[16rem] leading-none text-black">404</div>
          <div className="font-display text-3xl md:text-4xl mt-4 text-black">{t.title}</div>
          <p className="mt-4 text-neutral-600 max-w-md mx-auto">{t.body}</p>
          <Link to="/" className="mt-8 inline-flex bg-accent-yellow text-black btn-sharp rounded-full hover:bg-black hover:text-white transition-colors" data-testid="not-found-home">{t.cta}</Link>
        </div>
      </section>
    </>
  );
}
